import type { Seat } from '@central/api';

/** The reported seat nearest its limit (highest used/licensed), or undefined. */
export function fullestSeat(seats: Seat[]): (Seat & { used: number }) | undefined {
  let best: (Seat & { used: number }) | undefined;
  for (const s of seats) {
    if (s.used === undefined || s.licensed <= 0) continue;
    if (!best || s.used / s.licensed > best.used / best.licensed) best = { ...s, used: s.used };
  }
  return best;
}
